import { Home, Music, Film, PlusCircle, User } from "lucide-react";
import { NAV } from "@/constants/testIds";

export const NAV_ITEMS = [
  { to: "/", label: "Home", icon: Home, testId: NAV.home, end: true },
  { to: "/music", label: "Music", icon: Music, testId: NAV.music },
  { to: "/videos", label: "Videos", icon: Film, testId: NAV.videos },
  { to: "/upload", label: "Upload", icon: PlusCircle, testId: NAV.upload, accent: true },
  { to: "/profile", label: "Profile", icon: User, testId: NAV.profile },
];
